export const scrollToElement = (querySelector: string = '[data-not-valid="true"]') => {
  setTimeout(() => {
    const el = document.querySelector(querySelector);
    if (el) {
      el.scrollIntoView({ block: 'center', behavior: 'smooth' });
    }
  }, 100);
};
